import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '@theme/layouts';
import { PurchaseOrderCreationComponent } from './containers/purchase-order-creation/purchase-order-creation.component';
import { PurchaseOrderSimpleComponent } from '@app/modules/purchase-order/components/purchase-order-simple/purchase-order-simple.component';
import { SuppliersResolver } from '@shared/resolvers/suppliers.resolver';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'create',
        component: PurchaseOrderCreationComponent,
        resolve: {
          // purchaseOrder: PoDetailResolver,
        },
      },
      {
        path: 'create-simple',
        component: PurchaseOrderSimpleComponent,
        resolve: {
          suppliers: SuppliersResolver,
          // purchaseOrder: PoDetailResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PurchaseOrderRoutingModule {}
